import React, { useEffect, useRef, useState } from "react"
import {
  Dialog,
  DialogPanel,
} from "@headlessui/react"
import { X } from "@phosphor-icons/react"
import ImageThumb from "../Products/ProductDetailsSection/ImageThumb"
import InnerImageZoom from "react-inner-image-zoom"
import { Navigation } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"

import SliderButton from "@images/icons/slider-button.svg"

const ViewProductModal = ({ 
    isOpen = false, 
    onClose = () => {}, 
    selected = 1, 
    defaultImage, 
    thumbs, 
    productImages 
}) => {
    const [thumbSelected, setThumbSelected] = useState(null)
    const openState = isOpen || false;
    const [bigSelected, setBigSelected] = useState(defaultImage)
    const [isLoading, setIsLoading] = useState(false)

    const navigationPrevRef = useRef(null)
    const navigationNextRef = useRef(null)

    useEffect(() => {
        return () => setThumbSelected(null)
    }, [])

    useEffect(() => {
        setBigSelected(defaultImage)
    }, [defaultImage]);

    useEffect(() => {
        setIsLoading(false)
    }, [bigSelected])
    
    const handleClick = (index) => {
        setIsLoading(true)
        setBigSelected(productImages?.[index]?.src)
        setThumbSelected(index)
    }

    const handleClose = () => {
        setThumbSelected(null)
        if(onClose)
            onClose()
    }

    return (
        <React.Fragment>
            <Dialog open={openState} onClose={handleClose} className="relative z-[99]">
                <div className="fixed inset-0 w-screen h-screen lg:h-auto overflow-y-auto p-0 bg-black bg-opacity-60">
                    <div className="flex h-screen md:h-full w-screen bg-white lg:bg-transparent items-center justify-center">
                        <DialogPanel
                            transition
                            className="relative flex flex-col w-screen lg:w-full lg:max-w-[728px] h-screen lg:h-full max-h-[928px] space-y-0 lg:space-y-4 border bg-white p-0 lg:p-12"
                        >
                            <X
                                className="absolute top-0 right-0 cursor-pointer text-black m-4 z-50 rounded-full bg-white bg-opacity-50 p-2"
                                size={40}
                                weight="light"
                                onClick={() => {
                                    handleClose();
                                }}
                            />

                            <div className="relative max-w-full lg:max-w-[640px] h-[75%] lg:h-[70%]">
                                <div className={`inset-0 flex flex-col items-center h-full justify-center bg-white bg-opacity-75 ${isLoading ? 'block' : 'hidden'}`}>
                                    <div className="loader"></div>
                                    <div className="pt-2 pl-2">Loading...</div>
                                </div>
                                {
                                    (bigSelected && !isLoading) && 
                                        <>{
                                            productImages?.[thumbSelected]?.isVideo ? 
                                            <video className="mx-auto h-full" aria-label={'my-video'} preload="none" playsInline="playsinline" controls="controls" autoPlay="autoplay" muted="muted">
                                                <source 
                                                    src="https://blackboughswim.com/cdn/shop/videos/c/vp/463ef402350f400f98d26be8d9dd9e40/463ef402350f400f98d26be8d9dd9e40.HD-720p-2.1Mbps-35695865.mp4?v=0"
                                                    type="video/mp4" 
                                                />
                                                Your browser does not support the video tag.
                                            </video> :
                                            <InnerImageZoom
                                                // className="h-auto md:h-[calc(100vh_-_150px)] lg:h-auto"
                                                className="h-full w-full"
                                                key={thumbSelected !== null ? thumbSelected : selected}
                                                src={bigSelected}
                                                zoomSrc={bigSelected}
                                                zoomType="hover"
                                                zoomPreload={true}
                                                hideHint
                                                hideCloseButton
                                            />
                                        }</>
                                }  
                            </div>

                            <div className="w-full overflow-hidden pt-4 lg:pt-0">
                                <Swiper
                                    spaceBetween={5}
                                    slidesPerView={7.5}
                                    breakpoints={{300: {
                                        slidesPerView: 4.5,
                                        spaceBetween: 5,
                                    },
                                    768: {
                                        slidesPerView: 7.5,
                                    },
                                    900: {
                                        slidesPerView: 6.5,
                                    },
                                    1024: {
                                        slidesPerView: 6.5,
                                    },}}
                                    modules={[Navigation]}
                                    navigation={false}
                                    onBeforeInit={(swiper) => {
                                        swiper.params.navigation.prevEl = navigationPrevRef.current;
                                        swiper.params.navigation.nextEl = navigationNextRef.current;
                                    }}
                                    className="mySwiper"
                                >
                                    {
                                        thumbs && thumbs.map((item, index) => {
                                            return (
                                                <SwiperSlide key={`${item?.id}-${index}`}>
                                                    <ImageThumb
                                                        key={index}
                                                        image={item?.gatsbyImageData}
                                                        index={index}
                                                        selected={thumbSelected !== null ? thumbSelected : selected}
                                                        maxHeight="max-h-none"
                                                        onClick={() => handleClick(index)}
                                                        //isVideoThumbnail={index === 0 ? true : false}
                                                    />
                                                </SwiperSlide>
                                            );
                                        })
                                    }

                                    <div
                                        className="text-black size-4 p-2 rounded cursor-pointer z-30 absolute top-[40%] bottom-[60%]"
                                        ref={navigationPrevRef}
                                    >
                                        <img
                                            className="absolute -top-2 left-0 w-11 h-11 max-w-11"
                                            src={SliderButton}
                                            alt="slide-left"
                                        />
                                    </div>

                                    <div
                                        className="text-black size-4 p-2 rounded cursor-pointer z-30 absolute top-[40%] bottom-[60%] right-0"
                                        ref={navigationNextRef}
                                    >
                                        <img
                                            className="absolute -left-7 -top-2 w-11 h-11 max-w-11 transform rotate-180"
                                            src={SliderButton}
                                            alt="slide-left"
                                        />
                                    </div>
                                </Swiper>
                            </div>
                            {/* <div className="flex flex-nowrap flex-1 items-start max-w-full max-h-30 gap-2 md:gap-3 overflow-hidden overflow-x-scroll scrollbar-hide px-2 lg:px-0 !mt-2 lg:mt-0">
                                {thumbs?.map((item, index) => {
                                    return (
                                        <ImageThumb
                                            key={index}
                                            image={item?.gatsbyImageData}
                                            index={index}
                                            selected={thumbSelected}
                                            onClick={() => handleClick(index)}
                                        />
                                    );
                                })}
                            </div> */}
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    );
}

export default ViewProductModal
